import React, { useState, useContext, useEffect, MutableRefObject } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {ISimilarProps} from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import actions from '@state/actions';
import { IBrandImage } from '@state/brandsImages/types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { storageAccountName, containerNameBrands, containerName } from '@storage/azure-storage-blob';
import Loading from '@components/Loading';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { cloneDeep } from 'lodash';

const uuid = require('react-uuid');

const SimilarVehicles:React.FC<ISimilarProps> = (props) => {
  const authContext = useContext(AuthContext);
  let context = useContext(Context);
  const userData = authContext && authContext.userData?authContext.userData.profile:undefined;
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined);  
  const [vehicles, setVehicles] = useState<IBrandImage[]>([]);
  const [vehiclesChrome, setVehiclesChrome] = useState<IBrandImage[]>([]);    
  const [viewVehicles, setViewVehicles] = useState<IBrandImage[]>([]);
  const [page, setPage] = useState<number>(0);
  const [getBrand, setGetBrand] = useState(false);
  const [getChrome, setGetChrome] = useState(false);
  const pageSize = 5;
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  const urlFiles = `https://${storageAccountName}.blob.core.windows.net/${containerName}`
   let { editorStatus, data,selectDescribe, onCommandChange} = useContext(Context);

  const dispatch = useDispatch();
    
    const cleanStates=()=>
    {
        setGetBrand(false)
        setGetChrome(false)
        setIsLoading(false)
        setVehicles([])
        setVehiclesChrome([])
        setViewVehicles([])
    }


   
    useEffect(() => {            
        cleanStates();      
        if (props.attributes)
        {
            if (props.attributes.brandData && props.attributes.brandData.length>3)
            {            
              getVehicles(props.attributes.brandData[0], props.attributes.brandData[1], props.attributes.brandData[2], props.attributes.brandData[3],props.attributes.brandData[4],0)
            }        
        }                
    }, [props.attributes]);

    async function getVehicles(year:string, make:string, model:string, trim:string, type:string, start:number){
      const data: any = await fetchVehicles(year, encodeURIComponent(make), encodeURIComponent(model) , encodeURIComponent(trim), type, start, pageSize)         
      if (data) setVehicles(data);  
    }
    async function getVehiclesChrome(year:string, make:string, model:string, trim:string, type:string) {
      if (year && model && make && trim )
      {            
        const data: any = await fetchVehiclesChromeData(year, encodeURIComponent(make), encodeURIComponent(model), encodeURIComponent(trim??"") , encodeURIComponent(type))
        if (data) setVehiclesChrome(data);         
      }
    }
  

    useEffect(() => {        
         
 
      if (vehicles.length>0 )
      {                       
        let newarray = [...viewVehicles, ...vehicles];            
        setViewVehicles(newarray);
      }
      if (vehicles.length<pageSize && getBrand && !getChrome)
      {        
       
          if (props.attributes && props.attributes.brandData && props.attributes.brandData.length>3)
            getVehiclesChrome(props.attributes.brandData[0], props.attributes.brandData[1], props.attributes.brandData[2], props.attributes.brandData[3],props.attributes.brandData[4])

              
      }
  
      
    },[vehicles])

    useEffect(() => {
      if (vehiclesChrome.length>0 )
      {       

        let newarray = [...viewVehicles, ...vehiclesChrome!];    
        setViewVehicles(newarray);
      }
    
    },[vehiclesChrome])



 

    const fetchVehicles = (year: string, make: string, model: string, trim: string, type: string, start:number, length:number ) => {    
      setIsLoading(true)    
      return new Promise((resolve, reject) => {      
        dispatch(actions.brandsImages.fetchBrandsVehicles(year, make, model,trim,type, start,length, undefined, undefined,JSON.stringify(userData),(result, error) => {      
          
          setIsLoading(false)        
          if (error) reject(error)
          else {          
            setGetBrand(true);
            resolve(result)}
  
        }))
      });
    }
  
    const fetchVehiclesChromeData = (year: string, make: string, model: string, trim: string, type: string) => {
      setGetChrome(true)
      setIsLoading(true)    
      return new Promise((resolve, reject) => {      
        dispatch(actions.brandsImages.fetchBrandsVehiclesChromeData(year, make, model,trim,type, (result, error) => {      
          setIsLoading(false)
          if (error) reject(error)
          else {          
            resolve(result)}
  
        }))
      });
    }


  const getImageSrc = (data:IBrandImage)=>{        
    if (data.brandId!==undefined && data.brandId!==null)
      return `${urlBrand}/${data.brandId}/${data.imageType.toLowerCase()}/${data.srcImage}` + "TN";
    else
      return data.srcImage;
  }

  const handleScroll = async(e: any) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    
      if (bottom && !getChrome)
      {
        if (props.attributes && props.attributes.brandData && props.attributes.brandData.length > 3)      
        {
          getVehicles(props.attributes.brandData[0], props.attributes.brandData[1], props.attributes.brandData[2], props.attributes.brandData[3],props.attributes.brandData[4],(page + pageSize))        
          setPage(page+pageSize); 
        }
      }
  }


  const renderLoaderContainer = () => {
    if (isLoading)
      return(
        <S.LoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.LoaderContainer>
      );
  }


  return (
    <>
        
        {
              (viewVehicles && viewVehicles.length > 0) || isLoading ?
              <S.DesignsContainer id="infinite-scroll-all-vehicles" onScroll={handleScroll}>
              <S.DesignsWrap flex={true}>
                <TransitionGroup className="group-list" id="design-list">
                  {
                    viewVehicles && viewVehicles.length > 0 &&
                    viewVehicles.map((data: any, index: number) => {
                      return (
                        <CSSTransition key={index} timeout={600} classNames="item">
                          <div>
                            <S.PreviewContainer selected={index==selectedIndex}>
                              <S.ImgContainer height={86} src={getImageSrc(data)} onClick={()=>{setSelectedIndex(index); props.onSelect(cloneDeep(data))}}  transparent={data.types && data.types.length>0 && data.types[0].value === "Jellybean"}/>                              
                              {

                                (props.loadingImage??false) &&  index==selectedIndex &&
                                <Loading 
                                  id={"loading-image"}
                                  containerStyle={{position:'absolute', marginTop:'auto'}}
                                />
                              }
                            </S.PreviewContainer>
                          
                          </div>
                        </CSSTransition>
                      )
                    })
                  }
                </TransitionGroup>                            
              </S.DesignsWrap>
              {
                renderLoaderContainer()
              }
              </S.DesignsContainer>
              :
              <S.EmptyContainer>
              <p >There are no similar images available for this vehicle.</p>               
              <p>Search for vehicle images in the Brand Library by clicking the button above and providing the year, make, model, and trim that you're looking for</p>
              </S.EmptyContainer>
                }

        </>
  );
}

export default SimilarVehicles;